<template>
	<div class="">
		<!-- 管理页 -->
		<div v-if="articleEditPageVisible == false">
			<el-button type="primary" @click="articleTitle='新增资讯'; checkArticleId('create', 0)">新增资讯</el-button>
			<el-button type="success" @click="createArticle()">新增微信公众号文章</el-button>
			<el-select v-model="selectPart" clearable placeholder="请选择筛选分类" @change="partChange" style="margin-left: 10px;">
				<el-option v-for="item in articlePart" :key="item.value" :label="item.part" :value="item.value">
				</el-option>
			</el-select>

			<el-table :data="tableData" border style="width: 100%" v-loading="loading">
				<!-- <el-table-column prop="id" label="序号" width="60" align="center"></el-table-column> -->
				<el-table-column prop="mainImg" label="封面图" width="210">
					<template slot-scope="scope">
						<div v-if="scope.row.isWechatArticle == 1" class="table-img" v-lazy:background-image="scope.row.cdnUrl">
							<img src="../../assets/img/微信图标.png" style="width: 30px;"/>
						</div>
						<div v-else class="table-img" v-lazy:background-image="scope.row.mainImg.src"></div>
						
					</template>
				</el-table-column>
				<el-table-column prop="title" label="资讯标题" width="180">
					<template slot-scope="scope">
						<p v-if="scope.row.title.length > 40">{{scope.row.title.substring(0,42)}} ...</p>
						<p v-else>{{scope.row.title}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="content" label="资讯内容" width="320">
					<template slot-scope="scope">
						<p v-if="scope.row.content.length > 80">{{scope.row.content.substring(0,80)}} ...</p>
						<p v-else>{{scope.row.content}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="type" label="资讯类别" width="100" align="center">
					<template slot-scope="scope">{{checkArticleType(scope.row.part)}}</template>
				</el-table-column>
				<el-table-column prop="createDate" label="操作记录" width="180">
					<template slot-scope="scope">
						<p>创建时间:</p>
						<p>{{formatDate(scope.row.createDate)}}</p>
						<p>最近修改时间:</p>
						<p>{{formatDate(scope.row.lastAlterDate)}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="author" label="作者" width="100" align="center"></el-table-column>
				<el-table-column prop="status" label="状态" width="80" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 1">启用</span>
						<span v-else style="color: red;">停用</span>
						<el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ff4949"
							active-value="1" inactive-value="0" @click.native="changeStatus(scope.row)">
						</el-switch>
					</template>
				</el-table-column>
				<el-table-column label="操作" min-width="210">
					<template slot-scope="scope">
						<el-button v-if="scope.row.isWechatArticle == 1" type="success" icon="el-icon-edit"
							@click="modifyArticle(scope.row)"></el-button>
						<el-button v-else type="primary" icon="el-icon-edit"
							@click="articleTitle='编辑资讯'; checkArticleId('alter', scope.row)"></el-button>
						<el-button type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)"></el-button>
					</template>
				</el-table-column>
			</el-table>

			<!-- 分页条 -->
			<div class="block" style="margin: 10px 0;">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="pagination.currentPage" :page-sizes="pagination.pageSizes"
					:page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
					:total="pagination.total">
				</el-pagination>
			</div>
			
			<!-- 消息弹窗 -->
			<el-dialog :title="title" :visible.sync="dialogFormVisible">
				<el-form :model="formData">
					<el-form-item label="文章链接" :label-width="formLabelWidth">
						<el-input v-model="url" autocomplete="off" maxlength="1000" :disabled="formData.title != ''"></el-input>
					</el-form-item>
					<el-form-item v-if="formData.title" label="文章标题" :label-width="formLabelWidth">
						<el-input v-model="formData.title" autocomplete="off" maxlength="60" disabled></el-input>
					</el-form-item>
					<el-form-item v-if="formData.title" label="文章作者" :label-width="formLabelWidth">
						<el-input v-model="formData.author" autocomplete="off" maxlength="15" show-word-limit disabled></el-input>
					</el-form-item>
					<el-form-item v-if="formData.title" label="文章描述" :label-width="formLabelWidth">
						<el-input v-model="formData.description" type="textarea" autosize autocomplete="off" maxlength="120" show-word-limit disabled></el-input>
					</el-form-item>
					<el-form-item v-if="formData.title" label="文章分类" :label-width="formLabelWidth">
						<el-select v-model="formData.part" placeholder="请选择筛选分类">
							<el-option v-for="item in articlePart" :key="item.value" :label="item.part" :value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="formData.title" label="发布时间" :label-width="formLabelWidth">
						<div style="padding-left: 10px;">{{formatDate(formData.createDate)}}</div>
					</el-form-item>
					<el-form-item v-if="formData.cdnUrl" label="封面链接" :label-width="formLabelWidth">
						<el-input v-model="formData.cdnUrl" autocomplete="off" disabled></el-input>
					</el-form-item>
					<el-form-item v-if="formData.cdnUrl" label="封面预览" :label-width="formLabelWidth">
						<!-- referrerpolicy="no-referrer" -->
						<!-- 解决微信公众号文章无法显示的问题 -->
						<!-- 需配合<meta name="referrer" content="never"> -->
						<div style="height: 180px;">
							<img :src="formData.cdnUrl" referrerpolicy="no-referrer" 
							style="height:100%; border-radius: 6px;" />
						</div>	
					</el-form-item>
					
					
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="dialogFormVisible = false">取 消</el-button>
					<el-button v-show="formData.title && title == '新增'" @click="formDataInit()">重 置</el-button>
					<el-button v-show="title == '编辑'" @click="getWeChatArticle" :loading="btnLoading">重新读取</el-button>
					<el-button v-if="formData.title" type="primary" @click="handleCreateOrModify" :loading="btnLoading">确 定</el-button>
					<el-button v-else type="primary" @click="getWeChatArticle()" :loading="btnLoading">读 取</el-button>
				</div>
			</el-dialog>
			
		</div>

		<!-- 发布页 -->
		<div v-else>
			<el-page-header @back="articleEditPageVisible = false" :content="articleTitle" style="margin-bottom: 20px;">
			</el-page-header>
			<div style="display: flex;">
				<!-- 上传主图 -->
				<div style="margin-right: 15px; margin-bottom: 15px;">
					<el-upload class="avatar-uploader" :action="$http.defaults.baseURL + '/w-e-upload/mainImgUpload'"
						:show-file-list="false" :on-success="mainImgUploadSuccess" :before-upload="beforeMainImgUpload"
						:accept="'image/jpeg'">
						<img v-if="articleData.mainImgUrl" :src="articleData.mainImgUrl" class="avatar">
						<i v-else class="el-icon-upload avatar-uploader-icon">上传封面</i>
					</el-upload>
				</div>
				<div style="width: 100%; min-width: 800px; max-width: 1000px;">
					<div style="margin-bottom: 15px; display: flex; align-items: center;">
						<span style="flex-shrink: 0">标题：</span>
						<el-input v-model="articleData.title" placeholder="请输入文章标题" style="" maxlength="50"
							show-word-limit></el-input>
					</div>
					<div style="margin-bottom: 15px; display: flex; align-items: center;">
						<span style="flex-shrink: 0">作者：</span>
						<el-input v-model="articleData.author" placeholder="请输入作者名" style="" maxlength="10"
							show-word-limit></el-input>
					</div>
					<div>
						<div style="float: left;">
							<span style="flex-shrink: 0">类型：</span>
							<el-select v-model="articleData.part" placeholder="请选择">
								<el-option v-for="item in articlePart" :key="item.value" :label="item.part"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
						<div style="float: right;">
							<el-button v-if="articleData.id == 0" type="primary" @click="faBuWenZhang" :loading="btnLoading">发布文章</el-button>
							<el-button v-else type="primary" @click="bianJiWenZhang" :loading="btnLoading">编辑文章</el-button>
						</div>
					</div>
				</div>

			</div>
			<template>
				<div style="width: 100%; min-width: 1000px;">
					<div style="border: 1px solid #ccc;">
						<Toolbar style="border-bottom: 1px solid #ccc;" :editor="editor" :defaultConfig="toolbarConfig"
							:mode="mode" />
						<div style="background-color: #ccc; height: 600px; padding: 10px;">
							<Editor class="editor-container-style w-e-text" v-model="html" :defaultConfig="editorConfig"
								:mode="mode" @onCreated="onCreated" @onMaxLength="onMaxLength" />
						</div>
					</div>

					<!-- <el-button v-if="articleData.id == 0" style="margin-top: 20px;" type="primary" @click="faBuWenZhang">发布文章</el-button>
					<el-button v-else style="margin-top: 20px;" type="primary" @click="bianJiWenZhang">编辑文章</el-button> -->

					<!-- 展示部分 -->
					<!-- <div class="editor-content-view">
						<div v-html="html"></div>
					</div> -->

				</div>
			</template>
		</div>
	</div>
</template>

<script>
	import {
		Editor,
		Toolbar
	} from '@wangeditor/editor-for-vue'

	import axios from 'axios';

	export default {
		name: "loginNews",
		components: {
			Editor,
			Toolbar
		},
		data() {
			return {
				user: {},
				options: {},
				headers: {},
				tableData: [],
				pagination: {
					pageSizes: [5, 10, 20, 50],
					pageSize: 5,
					currentPage: 1,
					total: 0,
				},
				articleData: {
					id: 0,
					type: 4,
					part: 1,
					title: '',
					content: '',
					htmlContent: '',
					author: '',
					createDate: '',
					lastAlterDate: '',
					mainImgUrl: '',
					mainImgAlt: ''
				},
				loading: true,
				btnLoading: false,
				// 读取弹窗
				title: '',
				formLabelWidth: "80px",
				dialogFormVisible: false,
				url: '',
				formData: {
					id: 0,
					type: 4,
					part: 1,
					title: '',
					author: '',
					createDate: '',
					description: '',
					cdnUrl: '',
					status: 1
				},
				// 发布页
				articleEditPageVisible: false,
				articleTitle: '新增资讯',
				selectPart: null,
				articlePart: [{
					value: 1,
					part: '医疗动态'
				}, {
					value: 2,
					part: '行业新闻'
				}, {
					value: 3,
					part: '健康科普'
				}, {
					value: 4,
					part: '媒体报道'
				}, {
					value: 5,
					part: '患者之声'
				}],

				// wangEditor
				editor: null,
				html: '<p>hello</p>',
				toolbarConfig: {
					// toolbarKeys: [ /* 显示哪些菜单，如何排序、分组 */ ],
					excludeKeys: [ /* 隐藏哪些菜单 */
						'fullScreen', // 全屏
					],
				},
				editorConfig: {
					placeholder: '请输入内容...',
					// autoFocus: false,
					// 所有的菜单配置，都要在 MENU_CONF 属性下
					MENU_CONF: {
						lineHeight: {
							lineHeightList: ['1', '1.25', '1.5', '2', '2.5']
						},
						uploadImage: {
							// 后端上传地址，必填
							server: `${axios.defaults.baseURL}/w-e-upload/imageOrVideoUpload`,
							// form-data fieldName，后端接口参数名称，默认值wangeditor-uploaded-image
							fieldName: "file",
							// 2M，单个文件的最大体积限制，默认为 2M
							maxFileSize: 2 * 1024 * 1024,
							// 最多可上传几个文件，默认为 100
							maxNumberOfFiles: 10,
							// 选择文件时的类型限制，默认为 ['image/*'] 。如不想限制，则设置为 []
							allowedFileTypes: ['image/*'],
							// 5 秒，超时时间，默认为 10 秒
							timeout: 5 * 1000,
							onSuccess: (file, res) => {
								window.console.log(res);
								if (res.errno != 0) {
									this.$message({
										message: res.data,
										type: "warning"
									});
								}
							},
							onError: (file) => {
								// 文件大小超限错误
								if (file.size > 2 * 1024 * 1024) {
									this.$message({
										message: "图片不能大于2MB！",
										type: "warning"
									});
								} else {
									this.$message({
										message: "图片上传失败，请稍后重试！",
										type: "warning"
									});
								}
							}
							// 自定义上传参数，例如传递验证的 token 等。参数会被添加到 formData 中，一起上传到服务端。
							// meta: {
							//     token: 'xxx',
							//     otherKey: 'yyy'
							// },
							// 将 meta 拼接到 url 参数中，默认 false
							// metaWithUrl: false,
							// 自定义增加 http  header
							// headers: {
							//     Accept: 'text/x-json',
							//     otherKey: 'xxx'
							// },
							// 跨域是否传递 cookie ，默认为 false
							// withCredentials: false,
						},
						uploadVideo: {
							// 后端上传地址，必填
							server: `${axios.defaults.baseURL}/w-e-upload/imageOrVideoUpload`,
							// form-data fieldName，后端接口参数名称，默认值wangeditor-uploaded-video
							fieldName: "file",
							// 100M，文件大小限制，默认10M
							maxFileSize: 100 * 1024 * 1024,
							// 最多可上传几个文件，默认为 5
							maxNumberOfFiles: 3,
							// 选择文件时的类型限制，默认为 ['video/*'] 。如不想限制，则设置为 []
							allowedFileTypes: ['video/*'],
							// 15 秒，超时时间，默认为 30 秒
							timeout: 15 * 1000,
							onSuccess: (file, res) => {
								// window.console.log(res);
								if (res.errno != 0) {
									this.$message({
										message: res.data,
										type: "warning"
									});
								}
							},
							onError: (file) => {
								// 文件大小超限错误
								if (file.size > 100 * 1024 * 1024) {
									this.$message({
										message: "视频不能大于100MB！",
										type: "warning"
									});
								} else {
									this.$message({
										message: "图片上传失败，请稍后重试！",
										type: "warning"
									});
								}
							}
							// 自定义上传参数，例如传递验证的 token 等。参数会被添加到 formData 中，一起上传到服务端。
							// meta: {
							//     token: 'xxx',
							//     otherKey: 'yyy'
							// },
							// 将 meta 拼接到 url 参数中，默认 false
							// metaWithUrl: false,
							// 自定义增加 http  header
							// headers: {
							//     Accept: 'text/x-json',
							//     otherKey: 'xxx'
							// },
							// 跨域是否传递 cookie ，默认为 false
							// withCredentials: false,
						}
					}
				},
				mode: 'default', // or 'simple'
			};
		},
		mounted() {
			this.user = JSON.parse(sessionStorage.getItem('user'));
			this.articleData.author = this.user.nickname;

			let token = "Browser " + sessionStorage.getItem("token");
			//window.console.log(token);
			this.options = {
				headers: {
					Authorization: token
				}
			};
			this.headers = {
				Authorization: token
			};

			this.loadData();
		},
		methods: {
			handleSizeChange(val) {
				window.console.log(`每页 ${val} 条`);
				this.pagination.pageSize = val;
				this.loadData();
			},
			handleCurrentChange(val) {
				window.console.log(`当前页: ${val}`);
				this.pagination.currentPage = val;
				this.loadData();
			},
			partChange() {
				this.pagination.currentPage = 1;
				this.loadData();
			},
			loadData() {
				var data = {
					type: 4,
					part: this.selectPart,
					pageSize: this.pagination.pageSize,
					currentPage: this.pagination.currentPage,
				};

				this.loading = true;
				this.$http
					.post("/article/getList", data)
					.then(response => {
						window.console.log(response.data);
						this.tableData = response.data.data.articleList;
						this.pagination.total = response.data.data.total;

						this.loading = false;
					})
					.catch(e => {
						this.$message({
							message: "网络或程序异常！" + e,
							type: "error"
						});
					});
			},
			// 读取微信公众号文章相关
			createArticle() {
				this.title = '新增';
				this.dialogFormVisible = true;
				if (this.formData.id != 0) {
					this.formDataInit();
				}
			},
			modifyArticle(row) {
				this.title = '编辑';
				this.dialogFormVisible = true;
				this.formDataInit(row);
			},
			getWeChatArticle() {
				if (this.url == '' || !this.url.includes('mp.weixin.qq.com')) {
					this.$message.error("请输入正确的微信公众号文章链接!")
					return ;
				}
				this.btnLoading = true;
				var data = {url: this.url};
				this.$http
					.post("http://localhost:8888/wechat/getInfo", data)
					.then(response => {
						if (response.data.code == 200) {
							this.formData.title = response.data.data.title;
							this.formData.author = response.data.data.nickname;
							this.formData.createDate = response.data.data.createTime;
							window.console.log(this.formData.createDate)
							this.formData.description = response.data.data.description;
							this.formData.cdnUrl = response.data.data.cdnUrl;
							this.$message.success(response.data.message);
						} else {
							this.$message.error(response.data.message);
						}
						this.btnLoading = false;
					})
					.catch(e => {
						this.$message({
							message: "网络或程序异常！" + e,
							type: "error"
						});
						this.btnLoading = false;
					});
			},
			handleCreateOrModify() {
				var data = {
					id: this.formData.id,
					type: this.formData.type,
					part: this.formData.part,
					title: this.formData.title,
					author: this.formData.author,
					createDate: this.formData.createDate,
					content: this.formData.description,
					status: this.formData.status,
					isWechatArticle: 1,
					url: this.url,
					cdnUrl: this.formData.cdnUrl,
				};
				
				if (data.id == 0) { // 新增
					// window.console.log(data);
					this.btnLoading = true;
					this.$http
						.post("/wechat/create", data, this.options)
						.then(response => {
							if (response.data.code == 200) {
								this.$message.success(response.data.message);
							} else {
								this.$message.error(response.data.message);
							}
							this.btnLoading = false;
							this.dialogFormVisible = false;
							this.formDataInit();
							this.loadData();
						})
						.catch(e => {
							this.$message({
								message: "网络或程序异常！" + e,
								type: "error"
							});
							this.btnLoading = false;
						});
				} else { // 修改
					this.btnLoading = true;
					this.$http
						.post("/wechat/update", data, this.options)
						.then(response => {
							if (response.data.code == 200) {
								this.$message.success(response.data.message);
							} else {
								this.$message.error(response.data.message);
							}
							this.btnLoading = false;
							this.dialogFormVisible = false;
							this.formDataInit();
							this.loadData();
						})
						.catch(e => {
							this.$message({
								message: "网络或程序异常！" + e,
								type: "error"
							});
							this.btnLoading = false;
						});
				}
			},
			formDataInit(row) {
				if (row == '' || row == null) {
					this.url = '';
					this.formData = {
						id: 0,
						type: 4,
						part: 1,
						title: '',
						author: '',
						createDate: '',
						description: '',
						cdnUrl: '',
						status: 1
					};
				} else {
					this.url = row.url;
					this.formData = {
						id: row.id,
						type: row.type,
						part: row.part,
						title: row.title,
						author: row.author,
						createDate: row.createDate,
						description: row.content,
						cdnUrl: row.cdnUrl,
						status: row.status
					};
				}
				
			},
			checkArticleType(part) {
				switch (part) {
					case 1:
						return '医疗动态';
					case 2:
						return '行业新闻';
					case 3:
						return '健康科普';
					case 4:
						return '媒体报道';
					case 5:
						return '患者之声';
				}
			},
			changeStatus(row) {
				// window.console.log(row.status);
				var data = {
					id: row.id,
					status: row.status
				};
				this.$http
					.post("/article/changeStatus", data, this.options)
					.then(response => {
						if (response.data.code != 200) {
							this.$message.warning("Code: " + response.data.code + " " + response.data.message);
						}
					})
					.catch(e => {
						this.$message({
							message: "网络或程序异常！" + e,
							type: "error"
						});
					});
			},
			handleDelete(row) {
				this.$confirm("此操作将永久删除该文章, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(() => {
						// 已确认删除
						// 调接口删除
						var data = {
							id: row.id
						};
						this.loading = true;
						this.$http
							.post('/article/deleteById', data, this.options)
							.then(response => {
								this.loading = false;
								// window.console.log(response);
								if (response.data.code == 200) {
									this.$message({
										message: response.data.message,
										type: "success"
									});
								} else {
									this.$message.error("Code: " + response.data.code + " " + response.data
										.message);
								}

								this.loadData();
							})
							.catch(e => {
								this.$message({
									message: "网络或程序异常！" + e,
									type: "error"
								});
							});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除"
						});
					});
			},
			//时间格式化
			formatDate(isoString) {
				const date = new Date(isoString);

				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');

				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			// 检查文章id
			checkArticleId(operation, param) {
				this.articleEditPageVisible = true;
				if (operation == 'create' && this.articleData.id != 0) { // 新建文章
					this.articleData = {
						id: 0,
						type: 4,
						part: 1,
						title: '',
						content: '',
						htmlContent: '',
						author: this.user.nickname,
						createDate: '',
						lastAlterDate: '',
						mainImgUrl: '',
						mainImgAlt: ''
					};

				} else if (operation == 'alter') { // 修改文章
					this.articleData = {
						id: param.id,
						type: param.type,
						part: param.part,
						title: param.title,
						content: param.content,
						htmlContent: param.htmlContent,
						author: param.author,
						createDate: param.createDate,
						lastAlterDate: param.lastAlterDate,
						mainImgUrl: param.mainImg.src,
						mainImgAlt: param.mainImg.src.split('/').pop()
					};
					// window.console.log(this.articleData);
				}
				this.html = this.articleData.htmlContent;
			},
			// 发布页-主图上传
			mainImgUploadSuccess(res) {
				if (res.code == 200) {
					this.articleData.mainImgUrl = res.data.url;
					this.articleData.mainImgAlt = res.data.alt;
					this.$message.success('封面图片上传成功！')
				} else {
					this.$message.error(res.message);
				}
			},
			beforeMainImgUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isLt2M = file.size / 1024 / 1024 < 2;

				if (!isJPG) {
					this.$message.error('封面图片只能是 JPG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('封面图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;

			},

			// wangEditor
			onCreated(editor) {
				this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
				// 获取完整 HTML（包含样式）
				// this.html = editor.getHtml();
			},
			onMaxLength(editor) {
				window.console.log('onMaxLength', editor);
			},
			faBuWenZhang() {
				// window.console.log(this.editor.getText())
				if (!this.articleData.title || !this.articleData.author) {
					this.$message.warning('标题或作者不能为空！');
					return;
				} else if (!this.articleData.mainImgAlt || !this.articleData.mainImgUrl) {
					this.$message.warning('请添加封面图片！');
					return;
				} else if (this.html == '<p><br></p>') {
					this.$message.warning('请添加文章内容！');
					return;
				}
				this.articleData.content = this.editor.getText();
				this.articleData.htmlContent = this.html;
				// window.console.log(this.articleData);
				this.btnLoading = true;
				this.$http
					.post('/w-e-article/create', this.articleData, this.options)
					.then(response => {
						//window.console.log(response.data);
						this.btnLoading = false;
						if (response.data.code == 200) {
							this.$message.success(response.data.message);
							this.articleEditPageVisible = false;
							this.loadData();
						} else {
							this.$message.warning("Code: "+response.data.code+" "+response.data.message);
						}
					})
					.catch(e => {
						this.$message({
							message: "网络或程序异常！" + e,
							type: "error"
						});
					});
			},
			bianJiWenZhang() {
				if (!this.articleData.title || !this.articleData.author) {
					this.$message.warning('标题或作者不能为空！');
					return;
				} else if (!this.articleData.mainImgAlt || !this.articleData.mainImgUrl) {
					this.$message.warning('请添加封面图片！');
					return;
				} else if (this.html == '<p><br></p>') {
					this.$message.warning('请添加文章内容！');
					return;
				}
				this.articleData.content = this.editor.getText();
				this.articleData.htmlContent = this.html;
				// window.console.log(this.articleData);
				this.btnLoading = true;
				this.$http
					.post('/w-e-article/alter', this.articleData, this.options)
					.then(response => {
						//window.console.log(response.data);
						this.btnLoading = false;
						if (response.data.code == 200) {
							this.$message.success(response.data.message);
							this.articleEditPageVisible = false;
							this.loadData();
						} else {
							this.$message.warning("Code: "+response.data.code+" "+response.data.message);
						}
					})
					.catch(e => {
						this.$message({
							message: "网络或程序异常！" + e,
							type: "error"
						});
					});
			}
		},
		beforeDestroy() {
			const editor = this.editor
			if (editor == null) return
			editor.destroy() // 组件销毁时，及时销毁编辑器
		}
	};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
<style src="../../assets/css/wangEditorStyle.css"></style>

<style lang="scss" scoped>
	.el-table {
		margin-top: 20px;
	}

	.table-img {
		width: 188px;
		height: 80px;
		// background-color: transparent;
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		background-origin: content-box;
	}
	
	// 解决显示字数限制导致的遮挡问题，显示在框外
	::v-deep .el-textarea .el-input__count {
	    background-color: transparent;
	    bottom: -30px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 200px;
		height: 150px;
		line-height: 150px;
		text-align: center;
	}

	.avatar {
		width: 200px;
		height: 150px;
		display: block;
	}
</style>